<template>
	<div class="importCustomer main">
		<van-sticky>
			<div class="search-wrap">
				<img class="icon-search" src="@static/images/business/icon_search.png" alt="">
				<van-search v-model="value" @input='search' placeholder="搜索客户姓名或手机号">
				</van-search>
			</div>
		</van-sticky>
		<div class="customer-wrap">
			<van-index-bar :index-list="indexList" :sticky="false">
				<div v-for="(item, key) in indexList" :key="key">
					<van-index-anchor :index="item" />
					<div v-if="customerListMap[item]" class="list">
						<van-cell v-for="(cus, index) in customerListMap[item]" :key="index" :title="cus.fullName"
							@click="selItem(cus, key, index)">

							<template #title>{{ cus.fullName }}(尾号 {{ cus.phones | timeSubstr(7, 11) }})</template>
							<template #right-icon>
								<span class="import" v-if="cus.isExist == 1">已添加</span>
								<img v-else-if="cus.check && type != 1" class="icon-check"
									src="@static/images/business/icon_check.png" />
								<img v-else-if="type != 1" class="icon-check"
									src="@static/images/business/icon_uncheck.png" />
							</template>
						</van-cell>
					</div>
				</div>
			</van-index-bar>
		</div>
		<p class="total">共有{{ total }}位联系人</p>
		<!-- <div @click='loadCustomer'>导入啊啊啊</div> -->
		<div class="footer" v-if="type != 1 && !hideAll">
			<span v-if="!all" @click="checkAll(1)">全选</span>
			<span v-else @click="checkAll(2)">取消全选</span>
		</div>
	</div>
</template>
<script>
let timer = null;
import {
	loading
} from "@/api/mixins";
export default {
	mixins: [loading],
	data() {
		return {
			value: '', //搜索关键字
			list: [],
			indexList: [],
			type: '', //type 1 单选
			customerList: [],
			searchList: []
		};
	},
	computed: {
		hideAll() {
			return this.searchList.every(i => i.isExist == 1)
		},
		total() {
			let num = 0;
			num = this.searchList.length
			return num;
		},
		all() {
			let _tmp = false;
			_tmp = this.searchList.every(i => i.check)
			return _tmp;
		}
	},
	created() {
		let vm = this;
		this.type = this.$route.query.type;
		if (sessionStorage.getItem('ADDRESS_BOOK_CUSTOMER_LIST')) {
			this.customerList = JSON.parse(sessionStorage.getItem('ADDRESS_BOOK_CUSTOMER_LIST')).map((item, index) => {
				item.id = index + '' + item.phones
				return item;
			});
			this.searchList = JSON.parse(sessionStorage.getItem('ADDRESS_BOOK_CUSTOMER_LIST')).map((item, index) => {
				item.id = index + '' + item.phones
				return item;
			});
			this.getList();
		}
		if (this.$config.isApp && this.type != 1) {
			this.$app.toShowTitle("导入", () => {
				vm.loadCustomer()
			});
		}
	},
	beforeDestroy() {
		if (this.$config.isApp) { //app环境右上角展示 客户列表 快捷入口
			this.$app.hideRightIcon();
		}
	},
	methods: {
		getList() {
			let indexList = [],
				customerListMap = {};
			this.searchList.forEach(item => {
				let key = item.nameFirst.substr(0, 1);
				item.check = item.isExist == 1 || item.check ? true : false;
				if (indexList.indexOf(key) == -1) {
					indexList = [...indexList, key]
				}
				if (customerListMap[key]) {
					customerListMap[key] = [...customerListMap[key], item]
				} else {
					customerListMap[key] = [item]
				}
			})
			this.customerListMap = customerListMap;
			this.indexList = indexList;
		},
		selItem(item, index, secIdx) {
			console.log(item,index, secIdx)
			if (item.isExist == 1) return
			if (this.type == 1) {
				sessionStorage.setItem('IMPORT_CUSTOMER_INFO', JSON.stringify(item));
				this.$router.back();
				return
			}
			let idx = this.searchList.findIndex(i => i.id == item.id);
			console.log(idx)
			this.searchList.splice(idx, 1, {
				...item,
				check: !item.check
			})
			this.customerList.find(i => i.id == item.id).check = !item.check;
			if (this.type == 1) {
				this.searchList.forEach(cus => {
					item.id != cus.id ? cus.check = false : ''
				})
				this.customerList.forEach(cus => {
					item.id != cus.id ? cus.check = false : ''
				})
			}
			this.getList();
		},
		loadCustomer() {
			let arr = this.customerList.filter(item => item.check && item.isExist != 1)
			if (arr.length == 0) {
				this.$notice.msg('您还没有选择要导入的客户');
				return;
			}
			if (this.type == 1) {
				sessionStorage.setItem('IMPORT_CUSTOMER_INFO', JSON.stringify(arr[0]));
				this.$router.back();
			} else {
				this.$http({
					url: '/app/customer/saveBatch',
					type: 'POST',
					data: arr
				}).then(res => {
					this.$notice.msg(res.data);
					this.$router.back();
				}).catch(() => {
					// this.$notice.msg('导入失败，请稍后重试');
					this.$notice.msg(res.msg);
				})
			}


		},
		checkAll(type = 1) { //type 1全选  2取消全选 默认1
			this.searchList = this.searchList.map(item => {
				item.check = type == 1 ? true : (item.isExist == 1 ? true : false);
				return item;
			})
			this.customerList = this.customerList.map(item => {
				if (this.searchList.findIndex(i => i.phones == item.phones) !== -1) {
					item.check = type == 1 ? true : (item.isExist == 1 ? true : false);
				}
				return item;
			})
			this.getList();
		},
		search() {
			clearTimeout(timer)
			timer = setTimeout(() => {
				if (!this.value) {
					this.searchList = this.customerList;
				} else {
					this.searchList = this.customerList.filter(item => {
						return item.fullName.indexOf(this.value) !== -1 || item.phones.indexOf(this
							.value) !== -1
					})
				}
				this.getList();
			}, 500)
		},
	},
	components: {},
};
</script>

<style lang="scss" scoped>
.importCustomer {
	padding-bottom: 120px;

	.import {
		font-size: 28px;
		line-height: 40px;
		color: #727C8E;
	}

	/deep/.search-wrap {
		// position: fixed;
		// top: 0;
		background-color: #fff;
		.van-search {
			padding: 20px 30px;
		}

		.van-search__content {
			width: 690px;
			height: 66px;
			background: rgba(243, 243, 243, 0.39);
			border-radius: 8px;
			line-height: 66px;
			padding-left: 64px;
		}

		.icon-search {
			width: 24px;
			position: absolute;
			left: 50px;
			top: 40px;
		}

		.van-field__left-icon {
			display: none;
		}
	}

	/deep/.van-index-anchor {
		background-color: #F3F3F3;
		font-size: 28px;
		color: #727B8D;
		padding: 10px 30px;
		line-height: 40px;
	}

	.customer-wrap {
		// margin-top: 106px;
	}

	.list {
		/deep/.van-cell {
			padding: 28px 0;
			margin: 0 58px 0 32px;
			font-size: 32px;
			line-height: 45px;
			color: #17233D;
			width: unset;
			border-bottom: 1px solid #ECECEC;
		}

		.icon-check {
			width: 34px;
			height: 34px;
			margin: 0 20px;
		}

		& :last-child {
			border-bottom: none;
		}
	}

	/deep/.van-index-bar__index {
		font-size: 22px;
		line-height: 26px;
		color: #13233F;
		margin: 2px 0;
		padding: 0 20px;
	}

	.total {
		text-align: center;
		padding: 30px 0;
		height: 40px;
		font-size: 28px;
		line-height: 40px;
		color: #727B8D;
	}

	.footer {
		width: 750px;
		height: 100px;
		background: #F5F7FA;
		position: fixed;
		bottom: 0;
		left: calc(50%-375px);
		line-height: 100px;
		text-align: right;
		font-size: 30px;
		color: #236DFF;
		padding-right: 45px;

		span {
			padding: 20px;
		}
	}
}
</style>
